export default __webpack_public_path__ + "45468e24b9251be317e87ab0a913108f.png";